import React from "react";
import getSymbolFromCurrency from 'currency-symbol-map';
import styles from './../Prices.module.scss';

interface MonthlyPrice {
  name: string;
  currency_code: string;
  price: number;
  duration_metric: string;
}

interface SinglePriceWithPriceOnRequestProps {
  names: string[];
  prices: MonthlyPrice[];
}

const SinglePriceWithPriceOnRequest: React.FC<SinglePriceWithPriceOnRequestProps> = ({ names, prices }) => {
  return (
    <div>
        <div>
          <div key={prices[0].name} className={styles.container}>
            <span>
              {prices[0].name}
              &nbsp;
            </span>
            <div>
              <p>
                {`from ${getSymbolFromCurrency(prices[0].currency_code) || prices[0].currency_code} ${prices[0].price}`}
              </p>
              <span className={styles.duration}>
                {`/${prices[0].duration_metric || 'month'}`}
              </span>
            </div>
          </div>
        </div>
        <div>
            <div key={'price_on_request'} className={styles.container}>
            <span>
              {names.find(name => name !== prices[0].name)}
              &nbsp;
            </span>
            <p className={styles.price_on_request}>
              Price on request
            </p>
          </div>
        </div>
      </div>
  )
}

export default SinglePriceWithPriceOnRequest;